import SubHeadingElement from "@/app/(site)/_components/GCMolecules/SubHeadingElement"
import MediaGroup from "@/app/(site)/_components/GCSanityGroups/MediaGroup"
import GCBadge from "@/app/(site)/_components/Molecules/GCBadge"
import DynamicLink from "@/app/(site)/_components/Molecules/Link"
import { clsx } from "@/src/utils/clsx"
import { getGCGeneralLinkHref } from "@/src/utils/links/getGCGeneralLinkHref"
import { type CTAGroupType } from "@/types/gc-modules-types"

type CTAGroupProps = {
    CTAGroup: CTAGroupType
    isAboveTheFold?: boolean
    className?: string
    imageSizes?: string
    prefetch?: boolean
    imageAspect?: string
    enableHover?: boolean
    headingClassName?: string
}

type CTAGroupContentProps = {
    isAboveTheFold?: boolean
    imageSizes?: string
    CTAGroup: CTAGroupType
    imageAspect?: string
    headingClassName?: string
}

function CTAGroupContent({
    imageSizes,
    CTAGroup,
    isAboveTheFold,
    imageAspect = "aspect-[0.7]",
    headingClassName = "Trade_Gothic_Text_16_150_0_700"
}: CTAGroupContentProps) {
    const desktopMedia = CTAGroup.media
    const subHeadingGroup = CTAGroup.subHeadingGroup
    const badges = CTAGroup.badgeGroup?.content

    return (
        <>
            <div className={clsx("relative w-full", imageAspect)}>
                <MediaGroup
                    imageSizes={imageSizes}
                    isAboveTheFold={isAboveTheFold}
                    media={desktopMedia}
                />
                <div className="absolute left-8 top-8 flex gap-4">
                    {Array.isArray(badges) &&
                        badges.map(badgeItem => {
                            if (badgeItem._type === "textBadgeGroup") {
                                return (
                                    <GCBadge
                                        badgeText={badgeItem.text}
                                        textColor={badgeItem.textColor}
                                        backgroundColor={badgeItem.backgroundColor}
                                        key={badgeItem.text}
                                    />
                                )
                            }
                            return (
                                <GCBadge
                                    key={badgeItem.image.asset.url}
                                    badgeImage={badgeItem}
                                />
                            )
                        })}
                </div>
            </div>

            <div className="flex flex-col gap-4">
                <p className={headingClassName}>{CTAGroup.headingGroup.text}</p>
                {subHeadingGroup && (
                    <SubHeadingElement
                        textColor="text-secondary-text"
                        className="group-hover:text-main-black"
                        text={subHeadingGroup.text}
                    />
                )}
            </div>
        </>
    )
}

export default function CTAGroup({
    prefetch = false,
    imageSizes,
    CTAGroup,
    isAboveTheFold = false,
    className,
    imageAspect,
    enableHover = true,
    headingClassName
}: CTAGroupProps) {
    const uri = CTAGroup.gcGeneralLink
        ? getGCGeneralLinkHref(CTAGroup.gcGeneralLink)
        : null

    const wrapperClassName = clsx(
        "flex flex-col gap-12",
        enableHover && "group",
        className
    )

    if (uri) {
        return (
            <DynamicLink prefetch={prefetch} href={uri} className={wrapperClassName}>
                <CTAGroupContent
                    imageSizes={imageSizes}
                    isAboveTheFold={isAboveTheFold}
                    CTAGroup={CTAGroup}
                    imageAspect={imageAspect}
                    headingClassName={headingClassName}
                />
            </DynamicLink>
        )
    }

    return (
        <div className={wrapperClassName}>
            <CTAGroupContent
                imageSizes={imageSizes}
                isAboveTheFold={isAboveTheFold}
                CTAGroup={CTAGroup}
                imageAspect={imageAspect}
                headingClassName={headingClassName}
            />
        </div>
    )
}
